<template>
  <div>
    <baseEdit />
  </div>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'lossOverflowReportAdd',
    components: {
      baseEdit,
    },
  };
</script>
